import { White } from '@constants/color';
import { css } from '@emotion/react';

export const container = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '1920px',
  height: '1080px'
});
export const contentContainer = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  rowGap: '60px'
});
export const buttonContainer = css({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  columnGap: '24px'
});

export const title = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: White.White10,
  fontSize: '48px',
  fontWeight: 700
});
export const button = css({
  width: '320px',
  height: '80px'
});
